// removed by extract-text-webpack-plugin
module.exports = {"formLabel":"formLabel___1Dejf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HookFormInputs/FormError.module.less
// module id = 3785
// module chunks = 33